import { defineActions } from './defineActions'

/**
 * Document central (the attachments manager) and the redaction tools opened from a file.
 * Action names start with Document. The component is shared between modules, so the names
 * carry no module prefix: the module comes from the page's subject.
 */
export const documentActions = defineActions({
  'Document.Add': {
    label: 'Add file',
    area: 'Document central',
    description: 'Save in the Add File modal (links the uploaded file).',
  },
  'Document.Update': {
    label: 'Edit file',
    area: 'Document central',
    description: 'Save in the Edit File modal.',
  },
  'Document.Delete': { label: 'Delete file', area: 'Document central' },
  'Document.DetectPii': {
    label: 'Detect PII',
    area: 'Document central',
    description: 'Attachment Redaction tool: detect personal information.',
  },
  'Document.SaveRedactionSamples': {
    label: 'Save redaction learning samples',
    area: 'Document central',
    description: 'Attachment Redaction tool: Save as Learning Samples.',
  },
  'Document.ApplyRedaction': {
    label: 'Apply redaction',
    area: 'Document central',
    description:
      'Attachment Redaction tool: Apply Redaction in Redact (Blackout) mode.',
  },
  'Document.DeleteRedactedCopy': {
    label: 'Delete redacted file',
    area: 'Document central',
    description: 'Redaction status: Delete redacted file.',
  },
  'Document.RedactAgain': {
    label: 'Redact again',
    area: 'Document central',
    description: 'Redaction status: Redact again from the original.',
  },
})
